"use strict";
function handleSubmit(event, isNewsletterPage) {
    event.preventDefault();
    event.target.querySelector("button[type='submit']").textContent = 'Loading...';
    var form = event.target;
    var data = new FormData(form);
    var json = {};
    data.forEach(function (value, key) {
        json[key] = value;
    });
    var additionalTags = [];
    Object.keys(json).forEach(function (singleKey) {
        if (singleKey === 'additionalTags') {
            additionalTags.push(json[singleKey]);
        }
    });
    // Check for any influencer query params
    var urlParams = new URLSearchParams(window.location.search);
    var influencerTracking = urlParams.get('inf-track');
    if (influencerTracking) {
        additionalTags.push(influencerTracking);
    }
    json.additionalTags = additionalTags.join(',');
    var newsletterUrl = 'https://ccd-typescript-api-5341184e38bc.herokuapp.com/database/subscribe';
    // const newsletterUrl = 'https://untenaciously-superindependent-lilia.ngrok-free.dev/database/subscribe';
    fetch(newsletterUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(json)
    }).then(function (response) {
        response.json().then(function (jsonResponse) {
            if (additionalTags && arrayIncludesCustomNewsletter(additionalTags, "bf-2025")) {
                console.log('Facebook Event Tracking Sent');
                // @ts-ignore
                fbq('track', 'Lead', {
                    content_name: 'bf-2025-signup-success'
                });
                setTimeout(function () {
                    window.location.href = "https://coffeecapsulesdirect.co.za/pages/black-friday-2025-early-signup-entered";
                }, 500);
            }
            else {
                var message = jsonResponse.message || "";
                var result = jsonResponse.result || false;
                var html = "\n          <p>".concat(message, "</p>\n        ");
                if (isNewsletterPage) {
                    if (result) {
                        var queryParams = new URLSearchParams();
                        var interests_1 = [];
                        Object.keys(json).forEach(function (key) {
                            if (key.indexOf('Interested:') !== -1) {
                                var value = key.replace('Interested:', '').trim();
                                interests_1.push(value);
                            }
                        });
                        queryParams.append('interests', interests_1.join(','));
                        var url = "https://coffeecapsulesdirect.co.za/pages/newsletter-signup-success?".concat(queryParams.toString());
                        window.location.href = url;
                    }
                    else {
                        var responseTextElement = document.querySelector('.newsletter-page form .response');
                        if (responseTextElement) {
                            responseTextElement.style.display = 'flex';
                            responseTextElement.innerHTML = html;
                        }
                        var submitButton = document.querySelector(".newsletter-page button[type='submit']");
                        if (submitButton) {
                            submitButton.style.display = 'none';
                        }
                    }
                }
                else {
                    // Blog post signup
                    var formResponseTextElement = document.querySelector('.single-post .generic-form form .response');
                    if (formResponseTextElement) {
                        formResponseTextElement.style.display = 'block';
                        formResponseTextElement.innerHTML = html;
                    }
                    var resultBox = document.querySelector('.single-post .generic-form .result-box');
                    if (resultBox) {
                        resultBox.style.display = 'block';
                    }
                }
            }
        });
    });
}
var newsletterForm = document.querySelector('.newsletter-page form');
if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (event) {
        handleSubmit(event, true);
    });
}
var postForm = document.querySelector('.single-post .generic-form form');
if (postForm) {
    postForm.addEventListener('submit', function (event) {
        handleSubmit(event, false);
    });
}
function arrayIncludesCustomNewsletter(arr, target) {
    for (var i = 0; i < arr.length; i++) {
        if (arr[i] === target) {
            return true;
        }
    }
    return false;
}
var ccd11Checks = document.querySelectorAll('.limited-select input[type="checkbox"]');
ccd11Checks.forEach(function (singleCheck) {
    singleCheck.addEventListener('change', function (event) {
        var checkCount = document.querySelectorAll('.limited-select input[type="checkbox"]:checked').length;
        if (checkCount >= 3) {
            var uncheckedChecks = document.querySelectorAll('.limited-select input[type="checkbox"]:not(:checked)');
            uncheckedChecks.forEach(function (singleUncheckedCheck) {
                singleUncheckedCheck.disabled = true;
            });
        }
        else {
            var uncheckedChecks = document.querySelectorAll('.limited-select input[type="checkbox"]');
            uncheckedChecks.forEach(function (singleUncheckedCheck) {
                singleUncheckedCheck.disabled = false;
            });
        }
    });
});
